import { createContext, useContext } from 'react';

/** Updates the last interacted field name for fund_form_abandoned (field names only, never values). */
export type TrackOpenFundField = (fieldName: string) => void;

const OpenFundAnalyticsContext = createContext<TrackOpenFundField | null>(null);

export const OpenFundAnalyticsProvider = OpenFundAnalyticsContext.Provider;

export function useOpenFundFieldTracking(): TrackOpenFundField {
  const track = useContext(OpenFundAnalyticsContext);
  return track ?? (() => {});
}
